import React from 'react';
import { useConfig } from '../context/ConfigContext';
import useMenuWebSocket from '../hooks/useMenuWebSocket';
import './IceCreamProductsTV.css';
import fondoProductos from '../assets/FondoProductosFinal.webp';
import logoMiPiace from '../assets/LogoMiPiace.webp';

const IceCreamProductsTV = () => {
    const { config } = useConfig();
    
    // Hook WebSocket para actualizaciones en tiempo real
    const {
        iceCreamProducts,
        isConnected,
        isLoading,
        error,
        reconnect
    } = useMenuWebSocket(config?.shopBranchId);

    const formatPrice = (price) => {
        const numericPrice = parseFloat(price);
        return new Intl.NumberFormat('es-AR', {
            style: 'currency',
            currency: 'ARS',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(numericPrice);
    };

    if (isLoading) {
        return (
            <div 
                className="tv-screen-container"
                style={{
                    backgroundImage: `url(${fondoProductos})`
                }}
            >
                <img src={logoMiPiace} alt="Mi Piace" className="tv-logo" />
                <div className="tv-loading">
                    <div className="loading-spinner"></div>
                    <p>Conectando con el servidor...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div 
                className="tv-screen-container"
                style={{
                    backgroundImage: `url(${fondoProductos})`
                }}
            >
                <img src={logoMiPiace} alt="Mi Piace" className="tv-logo" />
                <div className="tv-error">
                    <p>❌ {error}</p>
                    <p className="connection-status">
                        {isConnected ? '🟢 Conectado' : '🔴 Desconectado'}
                    </p>
                    <button onClick={reconnect} className="retry-button">
                        Reconectar
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div 
            className="tv-screen-container"
            style={{
                backgroundImage: `url(${fondoProductos})`
            }}
        >
            <img src={logoMiPiace} alt="Mi Piace" className="tv-logo" />
            <div className="tv-content">
                {iceCreamProducts.length === 0 ? (
                    <div className="tv-empty">
                        <p>No hay productos de helados disponibles</p>
                    </div>
                ) : (
                    <div className="products-grid">
                        {[...iceCreamProducts]
                            .sort((a, b) => parseFloat(b.price) - parseFloat(a.price))
                            .map((product) => (
                            <div key={product.id} className="product-card">
                                <div className="product-info">
                                    <h3 className="product-name">{product.name}</h3>
                                    <div className="product-price">
                                        <span className="price-amount">
                                            {formatPrice(product.price)}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default IceCreamProductsTV; 